(() => {
  const builders = document.querySelectorAll('[data-discovery-builder]');

  builders.forEach((builder) => {
    const choices = Array.from(builder.querySelectorAll('input[name="sample_choice"]'));
    const submitButton = builder.querySelector('[data-discovery-submit]');
    const countElement = builder.querySelector('[data-discovery-count]');
    const statusElement = builder.querySelector('[data-discovery-status]');
    const maximum = Number(builder.dataset.max || 3);
    const variantId = Number(builder.dataset.builderVariant);

    const selectedChoices = () => choices.filter((choice) => choice.checked);

    const updateState = () => {
      const selected = selectedChoices();
      choices.forEach((choice) => {
        choice.disabled = !choice.checked && selected.length >= maximum;
      });
      countElement.textContent = `${selected.length} of ${maximum} selected`;
      submitButton.disabled = selected.length !== maximum || !variantId;
      statusElement.textContent = selected.length > maximum
        ? `Choose no more than ${maximum} fragrances.`
        : '';
    };

    choices.forEach((choice) => choice.addEventListener('change', updateState));

    builder.addEventListener('submit', async (event) => {
      event.preventDefault();
      const selected = selectedChoices();

      if (selected.length !== maximum || !variantId) {
        statusElement.textContent = `Please select exactly ${maximum} fragrances.`;
        return;
      }

      const properties = {};
      selected.forEach((choice, index) => {
        properties[`Sample ${index + 1}`] = choice.value;
      });

      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      statusElement.textContent = 'Adding your discovery set…';

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1,
              properties
            }]
          })
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'The discovery set could not be added.');
        }

        window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
      } catch (error) {
        statusElement.textContent = error.message || 'Something went wrong. Please try again.';
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
      }
    });

    updateState();
  });
})();
